import vue from '../main'
import axios from 'axios'
import Qs from 'qs'
export default {
  System: {
    alert (msg, title = "提示", type = -1) {
      switch (type) {
        case 0:
          type = "success";
          break;
        case 1:
          type = "warning";
          break;
        case 2:
          type = "info";
          break;
        case 3:
          type = "error";
          break;
        default:
          type = "";
          break;
      }
      return new Promise((resolve) => {
        vue.$alert(msg, title, {
          confirmButtonText: '确定',
          type: type,
          callback: action => {
            resolve();
          }
        });
      });
    },
    msg (msg, title = "提示", type = -1) {
      switch (type) {
        case 0:
          type = "success";
          break;
        case 1:
          type = "warning";
          break;
        case 2:
          type = "info";
          break;
        case 3:
          type = "error";
          break;
        default:
          type = "";
          break;
      }
      vue.$notify({
        title: title,
        message: msg,
        type: type
      });
    },
    confim (msg, title = "提示") {
      return new Promise((resolve, reject) => {
        vue.$confirm(msg, title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      });
    },
    load: {
      show (text = '加载中。。') {
        var load = vue.$loading({
          lock: true,
          text: text,
          spinner: 'el-loading-spinner',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      hide () {
        vue.$loading().close();
      }
    }
  },
  Phone: {
    alert (msg) {
      return new Promise((resolve) => {
        vue.$dialog.alert({
          message: msg
        }).then(() => {
          resolve();
        });
      });
    },
    msg (msg, type = -1) {
      switch (type) {
        case 0:
          type = "success";
          break;
        case 1:
          type = "fail";
          break;
        case 3:
          type = "cross";
          break;
        default:
          type = "";
          break;
      }
      vue.$toast({
        message: msg,
        icon: type
      });
    },
    confim (msg, title = "提示") {
      return new Promise((resolve, reject) => {
        vue.$dialog.confirm({
          title: title,
          message: msg
        }).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      });
    },
    load: {
      show (text = '加载中') {
        vue.$toast.loading({
          duration: 0,
          forbidClick: true,
          mask: true,
          message: text
        });
      },
      hide () {
        vue.$toast.clear();
      }
    }
  },
  Base64: {
    Encode (val) {
      return window.btoa(val);
    },
    Dencode (val) {
      return window.atob(val);
    }
  },
  ss: {
    Get (name) {
      return localStorage.getItem(name);
    },
    Set (name, value) {
      localStorage.setItem(name, value);
    }
  },
  cookie: {
    Get (name) {
      /*获取cookie参数*/
      var getCookie = document.cookie.replace(/[ ]/g, "");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
      var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
      var tips;  //声明变量tips
      for (var i = 0; i < arrCookie.length; i++) {   //使用for循环查找cookie中的tips变量
        var arr = arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
        if (name == arr[0]) {  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
          tips = arr[1];   //将cookie的值赋给变量tips
          break;   //终止for循环遍历
        }
      }
      return tips;
    },
    Set (name, value) {
      var date = new Date(); //获取当前时间
      var expiresDays = 1;  //将date设置为n天以后的时间
      date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000); //格式化为cookie识别的时间
      document.cookie = name + "=" + value + ";expires=" + date.toGMTString();  //设置cookie
    }
  },
  getQueryString (string) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == string) { return pair[1]; }
    }
    return "";
  },
  DateFormat (date, fmt = 'yyyy-MM-dd') {
    var o = {
      "M+": date.getMonth() + 1,                 //月份
      "d+": date.getDate(),                    //日
      "h+": date.getHours(),                   //小时
      "m+": date.getMinutes(),                 //分
      "s+": date.getSeconds(),                 //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },
  floatFormat (number, float = 2) {
    var s = number + "";
    if (s.indexOf(".") >= 0)
      return parseFloat(s.substring(0, s.indexOf(".") + (float + 1)));
    else
      return parseFloat(s)
  },
  Touch: {
    Close () {
      document.getElementsByTagName("body")[0].addEventListener('touchmove', (e) => {
        e.preventDefault();
      }, { passive: false });//阻止默认事件

    },
    Open () {
      document.getElementsByTagName("body")[0].addEventListener('touchmove', (e) => {
        e.returnValue = true;
      }, { passive: false });//打开默认事件
    }
  }
}